import { render, staticRenderFns } from "./Ratecard.vue?vue&type=template&id=111972e9&scoped=true"
import script from "./Ratecard.vue?vue&type=script&lang=js"
export * from "./Ratecard.vue?vue&type=script&lang=js"
import style0 from "./Ratecard.vue?vue&type=style&index=0&id=111972e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111972e9",
  null
  
)

export default component.exports